import React, { useState } from "react";
import { Popover } from "antd";

export default function LocationCard({
  payload,
}: {
  payload: {
    name?: string;
    url?: string;
    latitude: number;
    longitude: number;
  };
}) {
  const [showMapOptions, setShowMapOptions] = useState(false);

  // Google Maps Static API URL
  const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${
    payload.latitude
  },${payload.longitude}&zoom=15&size=400x200&markers=color:red%7C${
    payload.latitude
  },${payload.longitude}&key=${(window as any).firebaseAppConfig.apiKey}`;

  const openInGoogleMaps = () => {
    window.open(
      `https://www.google.com/maps?q=${payload.latitude},${payload.longitude}`,
      "_blank"
    );
    setShowMapOptions(false);
  };

  const openInWaze = () => {
    window.open(
      `https://waze.com/ul?ll=${payload.latitude},${payload.longitude}&navigate=yes`,
      "_blank"
    );
    setShowMapOptions(false);
  };

  const handleMapClick = () => {
    setShowMapOptions(true);
  };

  const openVenueUrl = (e: any) => {
    e.stopPropagation();
    window.open(payload.url, "_blank");
  };

  return (
    <div className="pt-2" style={{ maxWidth: "400px" }}>
      <div className="card-content p-0">
        {/* Map Image Container */}
        <Popover
          content={
            <div className="p-2">
              <p className="has-text-weight-semibold mb-2">Open with:</p>
              <div className="buttons">
                <button
                  className="button is-small is-primary"
                  onClick={openInGoogleMaps}
                >
                  <span className="icon">
                    <i className="fab fa-google"></i>
                  </span>
                  <span>Google Maps</span>
                </button>
                <button
                  className="button is-small is-info"
                  onClick={openInWaze}
                >
                  <span className="icon">
                    <i className="fas fa-route"></i>
                  </span>
                  <span>Waze</span>
                </button>
              </div>
            </div>
          }
          title={null}
          trigger="click"
          open={showMapOptions}
          onOpenChange={setShowMapOptions}
          placement="top"
        >
          <div
            className="is-relative"
            style={{ cursor: "pointer" }}
            onClick={handleMapClick}
          >
          <figure className="image is-2by1">
            <img
              src={mapUrl}
              alt={`Map location of ${payload.name}`}
              className="has-ratio"
              style={{ objectFit: "cover" }}
            />
          </figure>

          {/* Navigation Icon */}
          <button
            className="button is-white is-small"
            style={{
              position: "absolute",
              bottom: "8px",
              right: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              zIndex: 1000,
            }}
            onClick={handleMapClick}
          >
            <span className="icon">
              <i className="fas fa-location-arrow"></i>
            </span>
          </button>
          </div>
        </Popover>

        {/* Location Details */}
        <div className="p-4">
          <div className="media">
            <div className="media-left">
              <span className="icon has-text-info">
                <i className="fas fa-map-marker-alt fa-lg"></i>
              </span>
            </div>
            <div className="media-content">
              <p className="title is-5">{payload.name}</p>
              <p className="subtitle is-6 has-text-grey">
                {payload.latitude.toFixed(6)}, {payload.longitude.toFixed(6)}
              </p>
            </div>
          </div>

          {payload.url && (
            <div className="mt-3">
              <a
                href={payload.url}
                className="button is-light is-primary is-small is-fullwidth"
                onClick={openVenueUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="icon">
                  <i className="fas fa-external-link-alt"></i>
                </span>
                <span>{payload.name}</span>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
